import React, { useState } from 'react';
import Modal from './Modal'; // Import the Modal component
import Button from '../Button/Button';
import CardToogle from '../Toogle/CardToogle';
import { getEventExperienceSvgIcon } from '../../utilities';
import { theme } from '../../theme';
import Typography from '../Typography';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useEventCategories } from '../../hooks/useEventCategories';

const CreateEventExperienceModal = ({ experience, onSave, onClose }) => {
  const { t } = useTranslation(['createEvent', 'eventCategories']);
  const { experienceLevels } = useEventCategories();
  const [selectedExperience, setSelectedExperience] = useState(experience);

  return (
    <Modal onClose={onClose} title={t('createEventExperienceModal.title')} closeOnOverlayClick={false}>
      <ModalContent>
        <Typography as="p" $variant="body-1-medium" color={theme.colors.defaultWeak}>
          {t('createEventExperienceModal.description')}
        </Typography>
        <ExperienceList>
          {experienceLevels.map((experienceLevel) => (
            <CardToogle
              key={experienceLevel.key}
              category={experienceLevel.label}
              isActive={selectedExperience === experienceLevel.key}
              onClick={() => setSelectedExperience(experienceLevel.key)}
              icon={getEventExperienceSvgIcon(experienceLevel.key, selectedExperience === experienceLevel.key ? theme.colors.brandMain : theme.colors.defaultSubtle)}
            />
          ))}
        </ExperienceList>
      </ModalContent>
      <FormActions>
        <Button size="medium" onClick={() => { onSave?.(selectedExperience); onClose(); }}>
          {t('createEventExperienceModal.save')}
        </Button>
      </FormActions>
    </Modal>
  );
};

export default CreateEventExperienceModal;

const ModalContent = styled.div`
  align-items: flex-start;
  background-color: ${({ theme }) => theme.fill.defaultMain};
  border-radius: ${({ theme }) => theme.radius.sm};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.md};
  padding: ${({ theme }) => theme.sizing.sm};
  width: 100%;
`;


const ExperienceList = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.sizing.xs} ${({ theme }) => theme.sizing.xs};
  grid-template-columns: repeat(3, 1fr);
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const FormActions = styled.div`
  border-top: 1px solid ${({ theme }) => theme.border.defaultWeak};
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  text-align: center;
  width: 100%;
`;
